import { useGrid } from "common";

import { useParams } from "react-router-dom";
import {
  getIntegrationHistoryService,
  IntegrationHistoryFormItem,
  IntegrationHistoryListItem,
} from "./integrationHistoryApi";

export default function useIntegrationHistoryList() {
  const { integration_id } = useParams<"integration_id">();
  const service = getIntegrationHistoryService();
  const list = useGrid<IntegrationHistoryFormItem, IntegrationHistoryListItem>({
    storageType: "none",
    id: "IntegrationHistories",
    loadColumns: true,
    translationCategory: "IntegrationHistory",
    defaultPageSize: 10,
    defaultFilter: {
      integration_id,
    },

    exportFilter: filter => ({
      IntegrationHistorySearch: filter,
    }),
    ...service,
  });

  return list;
}
